import React from "react";
import { Box, Divider, Typography } from "@mui/material";
import { PersonOutline, PhoneAndroidOutlined } from "@mui/icons-material";

import { CardLayout, IconButton } from "../v3";

export const CustomerInfo = ({ projectDetails = {} }) => {
  const customerDetails = [
    {
      icon: <PersonOutline />,
      label: "Person Name",
      value: projectDetails?.client?.name,
    },
    {
      icon: <PhoneAndroidOutlined />,
      label: "Phone Number",
      value: projectDetails?.client?.primaryPhone || "N/A",
    },
  ];
  return (
    <CardLayout sx={{ margin: "11px" }}>
      {/* header */}
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, color: "#674BF5" }}>
          Customer Info
        </Typography>
      </Box>

      {/* customer details */}
      {customerDetails.map((item, index) => (
        <>
          <Box key={index} sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
            <IconButton
              icon={item?.icon}
              styles={{
                color: "#919191",
                backgroundColor: "transparent",
                borderColor: "#919191",
              }}
            />
            <Box>
              <Typography variant="caption" sx={{ color: "#757575", fontWeight: 500, display: "block" }}>
                {item?.label}
              </Typography>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                {item?.value}
              </Typography>
            </Box>
          </Box>
          {/* divider between items only */}
          {index < customerDetails.length - 1 && <Divider sx={{ borderColor: "#797979", my: 2 }} />}
        </>
      ))}
    </CardLayout>
  );
};
